import React from 'react';

import {
  Box,
  Typography,
} from '@material-ui/core';

interface Props {
  color: string;
  title: string;
  value: number;
  percentage: string;
}

const LegendItem = ({
  color,
  title,
  value,
  percentage,
}: Props) => {
  return (

    <Box
      mb={3}
      display="flex"
      alignItems="center"
    >

      <Box
        width={14}
        height={14}
        borderRadius="50%"
        mr={2}
        style={{
          background: color,
        }}
      />

      <Box>

        <Typography
          variant="subtitle2"
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          color="textSecondary"
        >
          {value.toLocaleString()}
        </Typography>

       { percentage && <Typography
          variant="caption"
          style={{
            color,
            fontWeight: 700,
          }}
        >
          {Number.isFinite(Number(percentage))
            ? `${Number(percentage).toFixed(2)}%`
            : "0.00%"}
        </Typography>}

      </Box>

    </Box>

  );

};

export default LegendItem;